export type HeaderNavItem = {
  readonly label: string
  readonly to: string
}

export type BranchOption = {
  readonly id: string
  readonly name: string
  readonly code: string
}

export const HEADER_NAV_ITEMS = [
  { label: "Trang chủ", to: "/" },
  { label: "Phòng nghỉ", to: "/phong-nghi" },
  { label: "Đặt phòng", to: "/dat-phong" },
  { label: "Thư viện ảnh", to: "/thu-vien-anh" },
  { label: "Quy định", to: "/chinh-sach" },
  { label: "Hướng dẫn và xem mã", to: "/huong-dan" },
] as const satisfies readonly HeaderNavItem[]

export const HEADER_BRANCHES = [
  { id: "can-tho", name: "Cần Thơ", code: "CT" },
  { id: "ho-chi-minh", name: "TP. Hồ Chí Minh", code: "HCM" },
  { id: "vinh-long", name: "Vĩnh Long", code: "VL" },
  { id: "ha-noi", name: "Hà Nội", code: "HN" },
  { id: "da-nang", name: "Đà Nẵng", code: "DN" },
  { id: "da-lat", name: "Đà Lạt", code: "DL" },
] as const satisfies readonly BranchOption[]

export const DEFAULT_BRANCH = HEADER_BRANCHES[0]
export const BRANCH_STORAGE_KEY = "nha-cam:selected-branch"
